import React, { ReactNode } from "react";
import { DialogPanel } from "@headlessui/react";

type ModalInnerProps = { children: ReactNode };

const ModalInner = ({ children }: ModalInnerProps) => {
  return (
    <DialogPanel
      transition
      className="bg-white rounded-lg text-left shadow-xl transition duration-300 ease-out sm:my-8 sm:max-w-md sm:w-full data-closed:scale-95 data-closed:opacity-0"
    >
      {children}
    </DialogPanel>
  );
};

export default ModalInner;
